/**
 * Constantes pour le contexte de layout
 *
 * @module layouts/constants/layoutContext
 */

import type { LayoutContext } from '@/layouts/types';

/**
 * Constantes pour les valeurs de LayoutContext
 * Utilisables dans les templates Vue et pour les comparaisons
 *
 * @example
 * import { LAYOUT_CONTEXT } from '@/layouts/constants';
 *
 * // Dans un template Vue
 * v-if="layoutContext === LAYOUT_CONTEXT.DESKTOP_WEB"
 *
 * // Dans du code TypeScript
 * if (context === LAYOUT_CONTEXT.MOBILE_WEB) { ... }
 */
export const LAYOUT_CONTEXT = {
  /** App Capacitor sur iOS/Android → TabBar + Modal */
  NATIVE_MOBILE: 'native-mobile',
  /** Site web sur navigateur mobile → TopBar + Drawer */
  MOBILE_WEB: 'mobile-web',
  /** Site web sur navigateur desktop → TopBar + SideMenu */
  DESKTOP_WEB: 'desktop-web',
} as const satisfies Record<string, LayoutContext>;
